<div class="withdrawal-dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Element: {{ (data.element.name.length > 30) ? (data.element.name | slice:0:30) + '...' : data.element.name }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Tab-Navigation für Entnahme/Rückgabe -->
  <div class="tab-navigation">
    <button mat-button [class.active]="activeTab === 'withdraw'" (click)="setActiveTab('withdraw')">
      <mat-icon>remove_shopping_cart</mat-icon> Entnahme
    </button>
    <button mat-button [class.active]="activeTab === 'return'" (click)="setActiveTab('return')">
      <mat-icon>add_shopping_cart</mat-icon> Hinzufügen/Zurückgeben
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Entnahme Form -->
    <div class="content-layout" *ngIf="activeTab === 'withdraw'">
      <!-- Element info section -->
      <div class="element-info-section">
        <div class="element-info-card">
          <h3>Element Informationen</h3>
          <div class="info-row">
            <span class="info-label">Name:</span>
            <span class="info-value">{{ data.element.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">ID:</span>
            <span class="info-value">{{ data.element.id }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Kategorie:</span>
            <span class="info-value">{{ data.element.kategorie }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Lager:</span>
            <span class="info-value">{{ data.element.lager }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Lagerort:</span>
            <span class="info-value">{{ data.element.lagerort }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Verfügbare Menge:</span>
            <span class="info-value">{{ data.element.quantity }}</span>
          </div>
        </div>
      </div>

      <!-- Withdrawal form section -->
      <div class="withdrawal-form-section">
        <h3>Entnahme registrieren</h3>
        <form [formGroup]="withdrawalForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Menge</mat-label>
            <input matInput type="number" formControlName="quantity" min="1" [max]="data.element.quantity">
            <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('required')">
              Bitte geben Sie eine Menge an
            </mat-error>
            <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('min')">
              Die Menge muss mindestens 1 sein
            </mat-error>
            <mat-error *ngIf="withdrawalForm.get('quantity')?.hasError('max')">
              Die Menge darf nicht größer als der verfügbare Bestand ({{ data.element.quantity }}) sein
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Zweck der Entnahme</mat-label>
            <input matInput formControlName="purpose" placeholder="z.B. Projekt, Reparatur, etc.">
            <mat-error *ngIf="withdrawalForm.get('purpose')?.hasError('required')">
              Bitte geben Sie einen Zweck an
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Kommentare (optional)</mat-label>
            <textarea matInput formControlName="comments" rows="2"></textarea>
          </mat-form-field>

          <div class="form-actions">
            <button mat-raised-button color="primary" type="submit" [disabled]="withdrawalForm.invalid || isSubmitting">
              <mat-icon>remove_shopping_cart</mat-icon>
              Element entnehmen
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Rückgabe Form -->
    <div class="content-layout" *ngIf="activeTab === 'return'">
      <!-- Element info section -->
      <div class="element-info-section">
        <div class="element-info-card">
          <h3>Element Informationen</h3>
          <div class="info-row">
            <span class="info-label">Name:</span>
            <span class="info-value">{{ data.element.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">ID:</span>
            <span class="info-value">{{ data.element.id }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Kategorie:</span>
            <span class="info-value">{{ data.element.kategorie }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Lager:</span>
            <span class="info-value">{{ data.element.lager }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Lagerort:</span>
            <span class="info-value">{{ data.element.lagerort }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Aktueller Bestand:</span>
            <span class="info-value">{{ data.element.quantity }}</span>
          </div>
        </div>
      </div>

      <!-- Return form section -->
      <div class="return-form-section">
        <h3>Element hinzufügen/zurückgeben</h3>
        <form [formGroup]="returnForm" (ngSubmit)="onReturn()">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Menge</mat-label>
            <input matInput type="number" formControlName="quantity" min="1">
            <mat-error *ngIf="returnForm.get('quantity')?.hasError('required')">
              Bitte geben Sie eine Menge an
            </mat-error>
            <mat-error *ngIf="returnForm.get('quantity')?.hasError('min')">
              Die Menge muss mindestens 1 sein
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Art der Hinzufügung</mat-label>
            <mat-select formControlName="returnType">
              <mat-option value="newAddition">Neue Hinzufügung</mat-option>
              <mat-option value="returnedItem">Rückgabe eines entnommenen Elements</mat-option>
            </mat-select>
            <mat-error *ngIf="returnForm.get('returnType')?.hasError('required')">
              Bitte wählen Sie die Art der Hinzufügung
            </mat-error>
          </mat-form-field>

          <div *ngIf="returnForm.get('returnType')?.value === 'returnedItem'">
            <mat-form-field appearance="outline" class="full-width" *ngIf="recentWithdrawals.length > 0">
              <mat-label>Bezieht sich auf Entnahme</mat-label>
              <mat-select formControlName="relatedWithdrawalId">
                <mat-option *ngFor="let withdrawal of recentWithdrawals" [value]="withdrawal.id">
                  {{ formatDate(withdrawal.timestamp) }} - {{ withdrawal.userName }} - {{ withdrawal.quantity }} Stück
                </mat-option>
              </mat-select>
            </mat-form-field>

            <p *ngIf="recentWithdrawals.length === 0" class="no-withdrawals-message">
              Es gibt keine kürzlich getätigten Entnahmen für dieses Element.
            </p>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Grund der Hinzufügung</mat-label>
            <input matInput formControlName="reason" placeholder="z.B. Neubestellung, Rückgabe, etc.">
            <mat-error *ngIf="returnForm.get('reason')?.hasError('required')">
              Bitte geben Sie einen Grund an
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Kommentare (optional)</mat-label>
            <textarea matInput formControlName="comments" rows="2"></textarea>
          </mat-form-field>

          <div class="form-actions">
            <button mat-raised-button color="accent" type="submit" [disabled]="returnForm.invalid || isSubmitting">
              <mat-icon>add_shopping_cart</mat-icon>
              Element hinzufügen
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Kombinierte Historie für Entnahmen und Rückgaben -->
    <div class="history-section">
      <h3>Entnahme- und Rückgabehistorie</h3>

      <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div class="no-history" *ngIf="!isLoading && historyItems.length === 0">
        <p>Keine Entnahmen oder Rückgaben für dieses Element vorhanden.</p>
      </div>

      <table mat-table [dataSource]="historyItems" class="history-table" *ngIf="!isLoading && historyItems.length > 0">
        <!-- Timestamp Column -->
        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef>Datum & Zeit</th>
          <td mat-cell *matCellDef="let item">{{ formatDate(item.timestamp) }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Typ</th>
          <td mat-cell *matCellDef="let item">
            <span class="history-badge" [ngClass]="item.type === 'withdrawal' ? 'withdrawal-badge' : 'return-badge'">
              {{ item.type === 'withdrawal' ? 'Entnahme' : 'Hinzufügung' }}
            </span>
          </td>
        </ng-container>

        <!-- User Name Column -->
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef>Benutzer</th>
          <td mat-cell *matCellDef="let item">{{ item.userName }}</td>
        </ng-container>

        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef>Menge</th>
          <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
        </ng-container>

        <!-- Purpose/Reason Column -->
        <ng-container matColumnDef="purpose">
          <th mat-header-cell *matHeaderCellDef>Zweck/Grund</th>
          <td mat-cell *matCellDef="let item">{{ item.purpose || item.reason }}</td>
        </ng-container>

        <!-- Comments Column -->
        <ng-container matColumnDef="comments">
          <th mat-header-cell *matHeaderCellDef>Kommentare</th>
          <td mat-cell *matCellDef="let item">{{ item.comments }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let item">
            <ng-container *ngIf="item.type === 'withdrawal'">
              <span *ngIf="item.isReturned" class="status-returned">
                <mat-icon class="status-icon">assignment_return</mat-icon>
                Zurückgegeben am {{ formatDate(item.returnTimestamp) }}
              </span>
              <span *ngIf="!item.isReturned" class="status-active">Aktiv</span>
            </ng-container>
            <ng-container *ngIf="item.type === 'return'">
              <span *ngIf="item.relatedWithdrawalId" class="status-return-reference">
                <mat-icon class="status-icon">reply</mat-icon>
                Bezieht sich auf Entnahme vom {{ getRelatedWithdrawalDate(item.relatedWithdrawalId) }}
              </span>
              <span *ngIf="!item.relatedWithdrawalId" class="status-new-addition">Neue Hinzufügung</span>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [ngClass]="{'returned-row': row.type === 'withdrawal' && row.isReturned}"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()">
      <mat-icon>arrow_back</mat-icon> Zurück
    </button>
  </mat-dialog-actions>
</div>
